import {
  useSessionStore,
  useVotingStore,
} from "@/stores";
import type {
  Nomination,
} from "@/types";
export function handleNominationMsg(params: Nomination | null) {
  const session = useSessionStore();
  if (!session.isPlayerOrSpectator) return;
  const votingStore = useVotingStore();

  votingStore.updateNomination({
    nomination: params,
  });
}
